module.exports = __webpack_public_path__ + "cd3d10060848554f9d942879dfb61425.png";